import { createActionCreator } from 'deox';

import { TPreviewLicenseSeatsMaterials, TPreviewLicenseSeatsResponse } from '@/services/api/company';

// CONSTANTS

export enum EPreviewLicenseSeatsAction {
  PREVIEW_LICENSE_SEATS = 'PREVIEW_LICENSE_SEATS',
  PREVIEW_LICENSE_SEATS_REQUEST = 'PREVIEW_LICENSE_SEATS_REQUEST',
  PREVIEW_LICENSE_SEATS_SUCCESS = 'PREVIEW_LICENSE_SEATS_SUCCESS',
  PREVIEW_LICENSE_SEATS_FAILED = 'PREVIEW_LICENSE_SEATS_FAILED',
}

// TYPES

export type TPreviewLicenseSeatsRequest = {
  type: EPreviewLicenseSeatsAction.PREVIEW_LICENSE_SEATS_REQUEST;
  payload: {
    materials: TPreviewLicenseSeatsMaterials;
    successCallback?: (response: TPreviewLicenseSeatsResponse) => void;
    failedCallback?: (err: unknown) => void;
  };
};

export type TPreviewLicenseSeatsSuccess = {
  type: EPreviewLicenseSeatsAction.PREVIEW_LICENSE_SEATS_SUCCESS;
  payload: { response: TPreviewLicenseSeatsResponse };
};

export type TPreviewLicenseSeatsFailed = { type: EPreviewLicenseSeatsAction.PREVIEW_LICENSE_SEATS_FAILED };

// FUNCTION

export const previewLicenseSeatsAction = {
  request: createActionCreator(
    EPreviewLicenseSeatsAction.PREVIEW_LICENSE_SEATS_REQUEST,
    (resolve) =>
      (
        materials: TPreviewLicenseSeatsMaterials,
        successCallback?: (response: TPreviewLicenseSeatsResponse) => void,
        failedCallback?: (err: unknown) => void,
      ): TPreviewLicenseSeatsRequest =>
        resolve({ materials, successCallback, failedCallback }),
  ),
  success: createActionCreator(
    EPreviewLicenseSeatsAction.PREVIEW_LICENSE_SEATS_SUCCESS,
    (resolve) =>
      (response: TPreviewLicenseSeatsResponse): TPreviewLicenseSeatsSuccess =>
        resolve({ response }),
  ),
  failure: createActionCreator(
    EPreviewLicenseSeatsAction.PREVIEW_LICENSE_SEATS_FAILED,
    (resolve) =>
      (error: any): TPreviewLicenseSeatsFailed =>
        resolve({ error }),
  ),
};
